<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách sổ liên lạc" :link="[{ text: 'Sổ liên lạc', href: '../contact-book' }]" />
      </div>
      <div>
        <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
      </div>
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ContactBookFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card outlined class="mx-4 elevation-0">
      <ContactBookDataTable ref="contact-book-data-table" />
    </v-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import get from 'lodash-es/get'
import utils from '@/plugins/utils'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ContactBookFilter from '@/modules/contactBook/ContactBookFilter.vue'
import ContactBookDataTable from '@/modules/contactBook/ContactBookDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    ContactBookFilter,
    ContactBookDataTable
  },
  methods: {
    ...mapActions('students', ['getAllStudents']),
    async onFilterChanged(newFilters) {
      this.$refs['contact-book-data-table'].searchStudents(newFilters)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        const headers = [...this.$refs['contact-book-data-table'].headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        const excelHeader = headers
          .map(({ text, value }) => ({ text, value }))
          .filter(excel => excel.value !== 'action')
        const filters = this.$refs['contact-book-data-table'].$options.filters
        const list = await this.getAllStudents({
          searchParams: { ...this.$refs['contact-book-data-table'].studentSearchParams, _start: 0, _limit: -1 },
          disableSave: true
        })
        const students = JSON.parse(JSON.stringify(list))
        const data = students.map(item => {
          item.code = filters.getStudentCode(item.code)
          item.status = filters.getContactBookStatus(item)
          item.classes = get(item.currentClass, 'title')
          item.dob = filters.ddmmyyyy(item.dob)
          item.phone = filters.getContactBookPhones(item)
          if (item.contactBook && item.contactBook.isApp && (item.fcmAndroid || item.fcmIos)) {
            item.senderMethod = filters.getNotificationMethod(item) + '(đã đăng nhập và bật thông báo APP)'
          } else if (item.contactBook && item.contactBook.isApp) {
            item.senderMethod = filters.getNotificationMethod(item) + '(chưa đăng nhập hoặc chưa bật thông báo APP)'
          } else {
            item.senderMethod = filters.getNotificationMethod(item)
          }
          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachSoLienLacHS')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
